function calculateFontSizeScale() {
  let originalWidth = 1920
   if (window.matchMedia('(max-width: 750px)').matches) {
       originalWidth = 750;
    } else {
       originalWidth = 1920;
    }
    const targetWidth = window.innerWidth;
    const scaleRatio = targetWidth / originalWidth;
    document.body.style.cssText =`--custom-font-size:${scaleRatio.toFixed(2)}`
    requestAnimationFrame(calculateFontSizeScale)
}

calculateFontSizeScale()
window.addEventListener('resize', calculateFontSizeScale);
